@if (!(edit | async)) {
  <div class="w-7rem cursor-pointer" (click)="edit.next(true)">
    <span [pTooltip]="value">{{
      value && value.length > 24 ? (value | slice: 0 : 24) + '...' : value
    }}</span>
  </div>
}
@if (edit | async) {
  <div>
    <span [formGroup]="inplaceForm" class="p-inputgroup w-12rem">
      <input
        (keyup.enter)="onKeyEnter($event)"
        (keyup.escape)="onKeyEscape($event)"
        class="text-sm w-full"
        type="text"
        pInputText
        [formControlName]="'value'"
      />
      <button
        (click)="updateValue()"
        pButton
        type="button"
        class="p-button-secondary border-top-none border-left-none border-bottom-none border-right-1 border-white"
        icon="fa fa-check"
        iconPos="left"
      ></button>
      <button
        (click)="close()"
        pButton
        type="button"
        class="p-button-secondary"
        icon="fa fa-times text-xl"
        iconPos="left"
        [loading]="isFormSubmitting"
      ></button>
    </span>
    @if (inplaceForm.get('value')?.touched && inplaceForm.invalid) {
      <app-error-msg
        [errors]="inplaceForm.errors"
        [errors]="inplaceForm.get('value')?.errors"
        [fieldLabel]="'Shared.TASK.TASK-CREATE.TASK_CATEGORY_NAME' | translate"
      />
    }
  </div>
}
